/**
 * 数据字典类型常量
 * 统一管理所有字典类型，便于维护和扩展
 */

// 字典类型常量
export const DICT_TYPES = {
  // 通用状态
  COMMON_STATUS: 'common_status',
  
  // 新闻相关
  NEWS_CATEGORY: 'news_category',
  NEWS_STATUS: 'news_status',
  NEWS_TAG: 'news_tag',
  
  // 机构相关
  INSTITUTION_TYPE: 'institution_type',
  INSTITUTION_STATUS: 'institution_status',
  
  // 展示相关
  SHOWCASE_CATEGORY: 'showcase_category',
  SHOWCASE_INDUSTRY: 'showcase_industry',
  SHOWCASE_TECHNOLOGY: 'showcase_technology',
  SHOWCASE_STATUS: 'showcase_status',
  
  // 用户相关
  USER_STATUS: 'user_status',
  USER_GENDER: 'user_gender',
  
  // 角色相关
  ROLE_STATUS: 'role_status',
  
  // 菜单相关
  MENU_TYPE: 'menu_type',
  MENU_STATUS: 'menu_status',
  
  // 权限相关
  PERMISSION_TYPE: 'permission_type',
  
  // 政策相关
  POLICY_BUSINESS_CATEGORY: 'policy_business_category',
  
  // 日志相关
  LOG_MODULE: 'log_module',
  LOG_ACTION: 'log_action',
} as const;

// 字典类型的中文名称映射
export const DICT_TYPE_LABELS = {
  [DICT_TYPES.COMMON_STATUS]: '通用状态',
  [DICT_TYPES.NEWS_CATEGORY]: '新闻分类',
  [DICT_TYPES.NEWS_STATUS]: '发布状态',
  [DICT_TYPES.NEWS_TAG]: '新闻标签',
  [DICT_TYPES.INSTITUTION_TYPE]: '机构类型',
  [DICT_TYPES.INSTITUTION_STATUS]: '机构状态',
  [DICT_TYPES.SHOWCASE_CATEGORY]: '展示分类',
  [DICT_TYPES.SHOWCASE_INDUSTRY]: '展示行业',
  [DICT_TYPES.SHOWCASE_TECHNOLOGY]: '核心技术',
  [DICT_TYPES.SHOWCASE_STATUS]: '展示状态',
  [DICT_TYPES.USER_STATUS]: '用户状态',
  [DICT_TYPES.USER_GENDER]: '用户性别',
  [DICT_TYPES.ROLE_STATUS]: '角色状态',
  [DICT_TYPES.MENU_TYPE]: '菜单类型',
  [DICT_TYPES.MENU_STATUS]: '菜单状态',
  [DICT_TYPES.PERMISSION_TYPE]: '权限类型',
  [DICT_TYPES.POLICY_BUSINESS_CATEGORY]: '政策业务分类',
  [DICT_TYPES.LOG_MODULE]: '日志模块',
  [DICT_TYPES.LOG_ACTION]: '日志操作',
} as const;

// 默认字典数据（用于初始化）
export const DEFAULT_DICT_DATA = {
  [DICT_TYPES.COMMON_STATUS]: [
    { dictLabel: '正常', dictValue: '1', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '停用', dictValue: '0', dictSort: 2, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.NEWS_CATEGORY]: [
    { dictLabel: '工作动态', dictValue: 'work_dynamics', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '行业新闻', dictValue: 'industry_news', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '通知公告', dictValue: 'notice', dictSort: 3, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.NEWS_STATUS]: [
    { dictLabel: '已发布', dictValue: '1', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '未发布', dictValue: '0', dictSort: 2, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.NEWS_TAG]: [
    { dictLabel: '知识产权', dictValue: 'intellectual_property', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '专利', dictValue: 'patent', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '商标', dictValue: 'trademark', dictSort: 3, status: 1, isDefault: 'N' },
    { dictLabel: '版权', dictValue: 'copyright', dictSort: 4, status: 1, isDefault: 'N' },
    { dictLabel: '政策', dictValue: 'policy', dictSort: 5, status: 1, isDefault: 'N' },
    { dictLabel: '服务', dictValue: 'service', dictSort: 6, status: 1, isDefault: 'N' },
    { dictLabel: '公告', dictValue: 'announcement', dictSort: 7, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.INSTITUTION_TYPE]: [
    { dictLabel: '代理机构', dictValue: 'agency', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '法律咨询', dictValue: 'legal_consultation', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '评估机构', dictValue: 'evaluation', dictSort: 3, status: 1, isDefault: 'N' },
    { dictLabel: '金融机构', dictValue: 'financial', dictSort: 4, status: 1, isDefault: 'N' },
    { dictLabel: '保险机构', dictValue: 'insurance', dictSort: 5, status: 1, isDefault: 'N' },
    { dictLabel: '高校、科研院所', dictValue: 'university_research', dictSort: 6, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.SHOWCASE_CATEGORY]: [
    { dictLabel: '专利技术', dictValue: 'patent_technology', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '商标品牌', dictValue: 'trademark_brand', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '版权作品', dictValue: 'copyright_work', dictSort: 3, status: 1, isDefault: 'N' },
    { dictLabel: '专利池', dictValue: 'patent_pool', dictSort: 4, status: 1, isDefault: 'N' },
    { dictLabel: '专利检索', dictValue: 'patent_search', dictSort: 5, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.SHOWCASE_INDUSTRY]: [
    { dictLabel: '制造业', dictValue: 'manufacturing', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '医疗健康', dictValue: 'medical_health', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '旅游业', dictValue: 'tourism', dictSort: 3, status: 1, isDefault: 'N' },
    { dictLabel: '传统工艺', dictValue: 'traditional_craft', dictSort: 4, status: 1, isDefault: 'N' },
    { dictLabel: '新能源汽车', dictValue: 'new_energy_vehicle', dictSort: 5, status: 1, isDefault: 'N' },
    { dictLabel: '信息技术', dictValue: 'information_technology', dictSort: 6, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.SHOWCASE_TECHNOLOGY]: [
    { dictLabel: '深度学习', dictValue: 'deep_learning', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '医学影像', dictValue: 'medical_imaging', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '人工智能', dictValue: 'artificial_intelligence', dictSort: 3, status: 1, isDefault: 'N' },
    { dictLabel: '物联网', dictValue: 'iot', dictSort: 4, status: 1, isDefault: 'N' },
    { dictLabel: '数据分析', dictValue: 'data_analysis', dictSort: 5, status: 1, isDefault: 'N' },
    { dictLabel: '工业4.0', dictValue: 'industry_4_0', dictSort: 6, status: 1, isDefault: 'N' },
    { dictLabel: '品牌设计', dictValue: 'brand_design', dictSort: 7, status: 1, isDefault: 'N' },
    { dictLabel: '旅游营销', dictValue: 'tourism_marketing', dictSort: 8, status: 1, isDefault: 'N' },
    { dictLabel: '文化传承', dictValue: 'cultural_heritage', dictSort: 9, status: 1, isDefault: 'N' },
    { dictLabel: '专利共享', dictValue: 'patent_sharing', dictSort: 10, status: 1, isDefault: 'N' },
    { dictLabel: '大数据', dictValue: 'big_data', dictSort: 11, status: 1, isDefault: 'N' },
    { dictLabel: '智能检索', dictValue: 'intelligent_search', dictSort: 12, status: 1, isDefault: 'N' },
    { dictLabel: '知识产权', dictValue: 'intellectual_property', dictSort: 13, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.SHOWCASE_STATUS]: [
    { dictLabel: '已发布', dictValue: '1', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '草稿', dictValue: '0', dictSort: 2, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.USER_STATUS]: [
    { dictLabel: '正常', dictValue: '1', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '禁用', dictValue: '0', dictSort: 2, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.USER_GENDER]: [
    { dictLabel: '男', dictValue: 'male', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '女', dictValue: 'female', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '未知', dictValue: 'unknown', dictSort: 3, status: 1, isDefault: 'Y' },
  ],
  [DICT_TYPES.ROLE_STATUS]: [
    { dictLabel: '正常', dictValue: '1', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '禁用', dictValue: '0', dictSort: 2, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.MENU_TYPE]: [
    { dictLabel: '目录', dictValue: 'catalog', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '菜单', dictValue: 'menu', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '按钮', dictValue: 'button', dictSort: 3, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.MENU_STATUS]: [
    { dictLabel: '正常', dictValue: '1', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '停用', dictValue: '0', dictSort: 2, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.PERMISSION_TYPE]: [
    { dictLabel: '菜单权限', dictValue: 'menu', dictSort: 1, status: 1, isDefault: 'N' },
    { dictLabel: '按钮权限', dictValue: 'button', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '数据权限', dictValue: 'data', dictSort: 3, status: 1, isDefault: 'N' },
  ],
  [DICT_TYPES.POLICY_BUSINESS_CATEGORY]: [
    { dictLabel: '政策性文件', dictValue: 'policy_documents', dictSort: 1, status: 1, isDefault: 'Y' },
    { dictLabel: '其他主动公开文件', dictValue: 'other_public_documents', dictSort: 2, status: 1, isDefault: 'N' },
    { dictLabel: '政策解读', dictValue: 'policy_interpretation', dictSort: 3, status: 1, isDefault: 'N' },
  ],
} as const;

export default DICT_TYPES;
